import i18n from "lib/i18n"
import PropTypes from "prop-types"
import React from "react"

import cc from "./cc.logo.svg"

const RepublishPanel = ({ onClick = () => {} }) => (
  <div className="hidden md:block print:hidden">
    <div className="mb-4 rounded-sm bg-gray-50 px-4 pt-4 pb-5 text-gray-800">
      <div className="mb-3">
        <img alt="CC BY ND" className="mb-4 w-24" src={cc} />
        <div className="font-sans-heading mb-2 text-lg leading-tight font-semibold">
          {i18n.t("republish_panel.title")}
        </div>
      </div>

      <div className="mb-4 font-sans text-base leading-tight font-normal">
        {i18n.t("republish_panel.body")}
      </div>

      <button
        className="w-full cursor-pointer rounded-sm border-none bg-gray-600 px-4 py-1.5 text-base font-bold text-white transition-colors duration-300 hover:bg-gray-800"
        onClick={onClick}
      >
        {i18n.t("republish_panel.button_text")}
      </button>
    </div>
  </div>
)

RepublishPanel.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default RepublishPanel
